const SettingsGetter = {
  settings: (state) => state.settings
};

export default SettingsGetter;
